import { render, staticRenderFns } from "./service_card.vue?vue&type=template&id=375386ec&scoped=true&"
import script from "./service_card.vue?vue&type=script&lang=js&"
export * from "./service_card.vue?vue&type=script&lang=js&"
import style0 from "./service_card.vue?vue&type=style&index=0&id=375386ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375386ec",
  null
  
)

export default component.exports